module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Agreement"
  }, [_c('div', {
    staticClass: "l-container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding": "5px 0"
    }
  }, [(_vm.agreement.student) ? [_c('h1', {
    staticClass: "m-name"
  }, [_vm._v("[" + _vm._s(_vm.agreement.id) + "] " + _vm._s(_vm.agreement.student.f_name) + " " + _vm._s(_vm.agreement.student.l_name) + "(" + _vm._s(_vm.agreement.student.f_name_kana) + " " + _vm._s(_vm.agreement.student.l_name_kana) + ") 様")])] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loading",
      "mode": "out-in"
    }
  }, [(_vm.agreement.student) ? [(_vm.agreement.student.family) ? [_c('router-link', {
    attrs: {
      "to": {
        name: 'familyindex',
        params: {
          id: _vm.agreement.student.family.id
        },
        exact: true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loading",
      "mode": "out-in"
    }
  }, [(_vm.agreement.student) ? [_c('router-link', {
    attrs: {
      "to": {
        name: 'studentindex',
        params: {
          id: _vm.agreement.student.id
        },
        exact: true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle"
  })])] : _vm._e()], 2), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_c('div', _vm._l((_vm.agreement.agreement_tags), function(list) {
    return _c('span', {
      key: list.id
    }, [_c('tag', {
      style: ({
        'backgroundColor': list.tag.color
      })
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times",
      on: {
        "click": function($event) {
          return _vm.deleteAgreementTag(list)
        }
      }
    }), _vm._v("\n              " + _vm._s(list.tag.name) + "\n            ")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tagInput"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.tags,
      "label": "name",
      "show-labels": false,
      "placeholder": "タグ追加"
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus",
    on: {
      "click": _vm.postAgreementTag
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('section-navi', [_c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'agreementindex',
        params: {
          id: _vm.agreement.id
        },
        exact: true
      },
      "exact": ""
    }
  }, [_vm._v("データ")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'agreementpdf',
        params: {
          id: _vm.agreement.id
        },
        exact: true
      }
    }
  }, [_vm._v("PDF")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'agreementhistory',
        params: {
          id: _vm.agreement.id
        },
        exact: true
      }
    }
  }, [_vm._v("対応履歴")])], 1), _vm._v(" "), _c('section-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.getVersionsAgreement(_vm.agreement.id)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'agreementdiff',
        params: {
          id: _vm.agreement.id
        },
        exact: true
      }
    }
  }, [_vm._v("変更履歴")])], 1)], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "agreement": _vm.agreement,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44acb71e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Agreement/Agreement.vue
// module id = 1359
// module chunks = 0